import Vue from "vue";
import VueRouter from "vue-router";
import CycleMoney from "../views/CycleMoney.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Daily",
    component: CycleMoney,
    children: [
      {
        path: ":id",
      }
    ]
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

export default router;
